export const ACCORDION_ANIMATION_TIMEOUT = { in: 300, out: 600 };

export const ALGORITHM_LOGO_URL =
  "https://resources.ebsco.zone/mfe-container/assets/images/Algorithm_Update_Icon.svg";

export const ALGORITHM_LOGO_PDF_URL =
  "https://resources.ebsco.zone/mfe-container/assets/images/Algorithm_Icon_1.svg";
